var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      { staticClass: "bg-white" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            attrs: {
              data: _vm.list,
              "element-loading-text": "Loading",
              stripe: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "ID", width: "80" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("div", [_vm._v(_vm._s(scope.row.id))])]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "名称", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.info_name) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "页面地址" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            packageB/pages/signup/signup?id=" +
                          _vm._s(scope.row.id) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "活动类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.info_type_des) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "联系人", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [_vm._v("微信：" + _vm._s(scope.row.wechat))]),
                      _vm._v(" "),
                      _c("div", [_vm._v("电话：" + _vm._s(scope.row.phone))]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "参与人数", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: { effect: "plain" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                path: "/signup/signIn?id=" + scope.row.id,
                              })
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(scope.row.sign_in_num) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            round: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                path: "/signup/edit?id=" + scope.row.id,
                              })
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            round: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.del({
                                id: scope.row.id,
                                index: scope.$index,
                              })
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex justify-center" },
          [
            _c("pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.listQuery.page_num > 0,
                  expression: "listQuery.page_num > 0",
                },
              ],
              attrs: {
                page: _vm.listQuery.start,
                "page-count": _vm.listQuery.page_num,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "start", $event)
                },
                pagination: _vm.getList,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }